import { render, staticRenderFns } from "./BrandsDetail.vue?vue&type=template&id=1819cf6c&"
import script from "./BrandsDetail.vue?vue&type=script&lang=js&"
export * from "./BrandsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports